import { render, staticRenderFns } from "./station-detail-history.vue?vue&type=template&id=115d236d&scoped=true&"
import script from "./station-detail-history.vue?vue&type=script&lang=js&"
export * from "./station-detail-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115d236d",
  null
  
)

export default component.exports